module.exports = __webpack_public_path__ + "downloads/Indicator.58ac7045.xlsx";